/* eslint-disable react-hooks/exhaustive-deps */
// Updated SideBar.js with your existing storage methods
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import SimpleBar from "simplebar-react";
import { NavLink as RouterLink, useNavigate } from "react-router-dom";

import sideLogo from "../../assets/img/svg/mommas.svg";
import "./Sidebar.scss";
import apiService from "../../services/ApiServices";
import * as Storage from '../../services/LocalStorage'

export default function SideBar() {
  const { config } = useSelector((state) => state.config);
  const [userPermissions, setUserPermissions] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  console.log("Config:", config);

  useEffect(() => {
    // Get user data based on config source
    const userData = getUserData();
    console.log("User Data:", userData);
    
    if (userData) {
      // Determine role - priority: userData.role > config.source
      const role = userData.role || config.source;
      setUserRole(role);
      console.log("User Role:", role);

      // For admin, show all components including permissions management
      if (role === "admin") {
        return;
      }

      // For vendor/restaurant and customer, fetch their permissions
      fetchUserPermissions(role);
    }
  }, [config]);

  const getUserData = () => {
    if (!config || !config.source) return null;
  
    try {
      let userData;
      
      switch(config.source) {
        case 'admin':
          userData = Storage.get('foodAdminData');
          // Additional check to ensure it's valid admin data
          if (userData) {
            const parsedData = typeof userData === 'string' ? JSON.parse(userData) : userData;
            if (!parsedData.token || (!parsedData.role && parsedData.role !== 'admin')) {
              console.log('Invalid admin data');
              return null;
            }
          }
          break;
        case 'vendor':
          userData = Storage.get('foodVendorData');
          break;
        case 'customer':
          userData = Storage.get('foodCustomerData');
          break;
        default:
          userData = Storage.get('foodUserData');
      }
  
      // If data is stringified, parse it
      if (userData && typeof userData === 'string') {
        userData = JSON.parse(userData);
      }
  
      return userData;
    } catch (error) {
      console.error('Error getting user data:', error);
      return null;
    }
  };

  const fetchUserPermissions = async (role) => {
    try {
      const apiBase = config?.api || apiService.APIURL;
      const response = await fetch(`${apiBase}permissions/${role}`);
      console.log("response",response);
      
      const result = await response.json();
      console.log("Results",result.data);
      
  
      if (result.success) {
        let permissions = result.data.permissions || []; // get permissions array from the role
        setUserPermissions(permissions);
  
        // Store in localStorage for offline access
        Storage.set('userPermissions', JSON.stringify(permissions));
      }
    } catch (error) {
      console.error('Error fetching permissions:', error);
      // fallback to localStorage
      const cachedPermissions = Storage.get('userPermissions');
      if (cachedPermissions) {
        try {
          setUserPermissions(JSON.parse(cachedPermissions));
        } catch (parseError) {
          console.error('Error parsing cached permissions:', parseError);
        }
      }
    }
  };
  

  const onLogout = () => {
    navigate("/");
    Storage.clear();
    window.location.reload();
  };

  const hasPermission = (component) => {
    // Admin can see everything
    if (userRole === "admin") return true;
  
    // For other roles, check if this component exists in the permissions array and is active
    return userPermissions.some(permission => permission.component === component && permission.isActive !== false);
  };
  

  console.log("User role",userRole);
  

  // Helper function to render menu items with permission check
  const renderMenuItem = (component, path, icon, text, extraProps = {}) => {
    if (!hasPermission(component)) return null;

    return (
      <div>
        <RouterLink className="mcsm-each" to={path} {...extraProps}>
          <i className={icon} style={{ fontSize: "24px" }}></i>
        </RouterLink>
        <p className="icon-text">{text}</p>
      </div>
    );
  };

  return (
    <div className="sidebar-main">
      <SimpleBar className="menu-simple-bar" style={{ height: "100%" }}>
        <div className="mc-sidebar">
          <div
            className="mcs-head"
            style={{ position: "sticky", top: 0, background: "#fff0da" }}
          >
            <img src={sideLogo} alt="" />
            <div className="sidebar-top-div">
              <h6 className="sidebar-heading">Momma's Kitchen</h6>
              <p className="sidebar-text">Relish; don't just eat</p>
            </div>
          </div>
          <div className="mcs-main">
            {/* Common components with permission check */}
            {renderMenuItem('dashboard', '/dashboard', 'fa-solid fa-list', 'Dashboard')}
            {renderMenuItem('finance', '/finance', 'fa-sharp fa-solid fa-coins', 'Finance')}
            {renderMenuItem('orders', '/orders', 'fa-brands fa-jedi-order', 'Orders')}
            {renderMenuItem('party-orders', '/party-orders', 'fa-brands fa-first-order', 'Party Orders')}
            {renderMenuItem('menu', '/menu', 'fa-solid fa-bars', 'Menu')}
            {renderMenuItem('tags', '/tags', 'fa-solid fa-tags', 'Tags')}
            {renderMenuItem('delivery', '/delivery', 'fa-solid fa-truck', 'Delivery')}
            {renderMenuItem('profile', '/profile', 'fa-solid fa-address-book', 'Profile')}
            {renderMenuItem('assigned_orders', '/assigned_orders', 'fa-solid fa-person', 'Assigned Orders', {
              style: { wordBreak: "break-word", width: "65px" }
            })}
            {renderMenuItem('banking-details', '/banking-details', 'fa-solid fa-building-columns', 'Bank Info')}


            {/* Admin-only components */}
            {userRole === "admin" && (
              <>
                <div>
                  <RouterLink className="mcsm-each" to={"/permissions"}>
                    <i className="fa-solid fa-shield-alt" style={{ fontSize: "24px" }}></i>
                  </RouterLink>
                  <p className="icon-text">Permissions</p>
                </div>
                <div>
                  <RouterLink className="mcsm-each" to={"/customers"}>
                    <i className="fa-solid fa-user" style={{ fontSize: "24px" }}></i>
                  </RouterLink>
                  <p className="icon-text">Customers</p>
                </div>
                <div>
                  <RouterLink className="mcsm-each" to={"/hosts"}>
                    <i className="fa-solid fa-user" style={{ fontSize: "24px" }}></i>
                  </RouterLink>
                  <p className="icon-text">Hosts</p>
                </div>
                <div>
                  <RouterLink className="mcsm-each" to={"/cuisine"}>
                    <i className="fa-solid fa-bowl-food" style={{ fontSize: "24px" }}></i>
                  </RouterLink>
                  <p className="icon-text">Cuisine</p>
                </div>
                <div>
                  <RouterLink className="mcsm-each" to={"/bank-list"}>
                    <i className="fa-solid fa-building-columns" style={{ fontSize: "24px" }}></i>
                  </RouterLink>
                  <p className="icon-text">Bank List</p>
                </div>
                <div>
                  <RouterLink className="mcsm-each" to={"/social-links"}>
                    <i className="fa-solid fa-icons" style={{ fontSize: "24px" }}></i>
                  </RouterLink>
                  <p className="icon-text">Social Links</p>
                </div>
              </>
            )}
          </div>

          <div className="sidebar-logout" onClick={onLogout}>
            <span className="logout-icon">
              <i className="fa-solid fa-power-off"></i>
            </span>
            <span className="icon-text">Log Out</span>
          </div>
        </div>
      </SimpleBar>
    </div>
  );
}